import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen flex items-center justify-center font-mono text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
